new Glider(document.querySelector('.custom-featured-collection .slider-wrapper > ul'), {
  // Mobile-first defaults
  slidesToShow: 2,
  slidesToScroll: 1,
  draggable: true,
  dots: '.glider-dots',
  arrows: {
    prev: '.glider-prev',
    next: '.glider-next'
  },
  responsive: [
    {
      // screens greater than >= 750px
      breakpoint: 750,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1,
      }
    },
    {
      // screens greater than >= 990px
      breakpoint: 990,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
      }
    }
  ]
})